export const PATH_HOME = "/";
export const PATH_PREMIUM_OFFERS_SHOP = `${PATH_HOME}premium-offers/`;

export const PATH_HOME_TERMS = `${PATH_HOME}terms/`;
export const PATH_TERMS_COMPLIMENTARY_NIGHT = `${PATH_HOME_TERMS}complimentary-night/`;

// Wishlist related paths
export const PATH_FAVORITES = `${PATH_HOME}favorites/`;
export const API_V0_VERSION_PREFIX: string = "/api/v0";
export const WISHLISTS_API_PREFIX: string = `${API_V0_VERSION_PREFIX}/travel/wishlists/`;
